var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex"},[_c('sidebar'),_c('div',{staticClass:"flex flex-col w-full scroll-pane scrollbar"},[_c('card-carousel',{staticClass:"flex-auto"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }